<script setup lang="ts">

import {ArrowDownBold, ArrowUpBold} from "@element-plus/icons-vue";

const model = defineModel();
const props = defineProps({
  isOpen: Boolean,
  title: String,
});
</script>

<template>
  <div class="flex items-center h-full">
    <el-dropdown trigger="click" @visible-change="val => isOpen = val">
        <span class="el-dropdown-link flex items-center">
          {{ title }}
          <el-icon class="el-icon--right ml-1">
            <component :is="isOpen ? ArrowUpBold : ArrowDownBold" />
          </el-icon>
        </span>
      <template #dropdown>
        <div class="p-4 bg-background-light shadow-lg rounded">
          <el-input-number v-model="model" :min="1" />
        </div>
      </template>
    </el-dropdown>
  </div>
</template>

<style scoped>

</style>
